import { render, staticRenderFns } from "./NotificationsByCif.vue?vue&type=template&id=6337e8fa"
import script from "./NotificationsByCif.vue?vue&type=script&lang=js"
export * from "./NotificationsByCif.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports